import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ColorScssService } from '../../shared/service/color-scss.service';
import {SeoService} from '../../Services/SEO/seo.service';

@Component({
  selector: 'app-enterprice-sass',
  templateUrl: './enterprice-sass.component.html',
  styleUrls: ['./enterprice-sass.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EnterpriceSassComponent implements OnInit {

  constructor(
      private route: ActivatedRoute,
      private title: Title,
      private seoService: SeoService,
      public colorPicker: ColorScssService,
  ) { }


  ngOnInit() {
    this.seoService.setMetaData("homepage");
    this.colorPicker.setColorScheme('color-8');
  }

}
